import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class B2bAdditionalIncomeComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/income-info';
  }

  public static regex(): RegExp {
    return /\/statement\/\d+\/income-info((\/?#?)|(\/?#.*?))$/;
  }
}
